<template>
  <div class="card horizontal-card hotel" :data-utag-eec='`${hotel.data_eec}`'>
    <div class="card-top-content">
      <span v-if="hotel.nst" class="badge badge-tcl">
            <i class="s s-logo_club s-2x"></i>{{$t('commons.destination_the_club')}}
        </span>
      <div class="card-image">
        <!--[if IE 9]><video style="display: none;"><![endif]-->
        <v-lazy-image
          v-if="hotel.images[0]"
          :src="hotel.images[0].desktop.crops[0]"
          :alt="hotel.images[0].image_alt"
          use-picture
        >
          <source v-if="hotel.images[0].tablet" :srcset="hotel.images[0].desktop.crops[0]" media="(min-width: 1024px)">
          <source v-if="hotel.images[0].tablet" :srcset="hotel.images[0].tablet.crops[0]" media="(min-width: 769px)">
          <source v-if="hotel.images[0].tablet" :srcset="hotel.images[0].mobile.crops[0]" media="(max-width: 767px)">
          <source v-if="!hotel.images[0].tablet" :srcset="hotel.images[0].desktop.crops[0]" media="(min-width: 769px)">
          <source v-if="hotel.images[0].mobile" :srcset="hotel.images[0].mobile.crops[0]" media="(max-width: 768px)">
          <source v-if="!hotel.images[0].tablet" :srcset="hotel.images[0].mobile.crops[0]">
        </v-lazy-image>
      </div>
      <div class="card-container">
        <div :class="`text ${isPrivateArea ? 'private' : 'no-private'}`">
          <div class="text-header">
            <p class="location t-label">
              <span>{{hotel.city}}</span>
            </p>
            <a v-if="isPrivateArea" class="title-link t-highlight hide-in-app" target="_blank"
              :href="hotel.url">{{hotel.title}}</a>
              <a v-if="isPrivateArea" class="title-link t-highlight show-in-app"
              :href="hotel.url">{{hotel.title}}</a>
            <span v-if="!isPrivateArea" class="title-link t-highlight">{{hotel.title}}</span>
            <div class="stars"><span :class="`rating-stars r${hotel.categories[0]}`"></span></div>
          </div>
          <div class="row pills-cnt">
            <ul class="badges-list js-segment-badges-personalization" data-limit="2" data-mobile-limit="0">
              <li v-for="(badge, idx) in hotel.hotel_badges.slice(0,2)"
                  :key="idx"
                  :badge-id="badge.id"
                  data-badge-segment="only_adults"
              >
                <a :class="`badge fancybox`"
                    data-fancybox=""
                    data-append-value="true"
                    :href="`#badge-${badge.id}`"
                >{{badge.title}}</a>
                <div :id="`badge-${badge.id}`" class="hidden">
                  <div class="badges-content">
                    <div class="badges-item">
                      <p class="block-title">
                        <span :id="`#badge-${badge.id}`"
                              :class="`badge-plain`"
                        >{{badge.title}}</span>
                      </p>
                      <div class="desc">
                        <p>{{badge.description}}</p>
                      </div>
                      <a class="l-external hide-in-app" v-if="isPrivateArea == true" target="_blank" :href="badge.url">{{badge.link_text}}</a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="all-badges">
                <a v-if="hotel.hotel_badges.length > 2"
                    class="badge fancybox blue"
                    data-fancybox=""
                    data-mobile-text="Servicios"
                    :href="`#all-badges-${hotel.id}`"
                    >+{{hotel.hotel_badges.slice(2).length}}
                    {{$t("shared.badges.services")}}</a>
              </li>
            </ul>
            <div class="all-badges" v-if="hotel.hotel_badges.length > 2">
              <div :id="`all-badges-${hotel.id}`" class="hidden">
                <div class="badges-content js-segment-badges-personalization">
                  <div v-for="(badge, idx) in hotel.hotel_badges"
                      :key="idx" class="badges-item" :data-badge-id="badge.id" data-badge-segment="only_adults">
                    <p class="block-title">
                      <span id="#badge-${badge.id}" class="badge-plain green">{{badge.title}}</span>
                    </p>
                    <div class="desc">
                      <p>{{badge.description}}</p>
                    </div>
                    <a class="l-external hide-in-app" target="_blank" :href="badge.url">{{badge.link_text}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul class="info-links">
            <li class="info-link utag-info-link">
              <a :data-multi-modal-trigger="hotel.id"
                  data-type="hotel"
                  :data-lat="hotel.lat"
                  :data-lng="hotel.lng"
                  :data-zoom="hotel.gmaps_zoom"
                  :data-name="hotel.title"
                  data-current-tab="#info-tab"
                  href="#"
                >
                <span>{{$t('shared.cards.hotel.info_links.info')}}</span>
              </a> </li>
            <li class="info-link utag-popup-show-photos">
              <a :data-multi-modal-trigger="hotel.id"
                  data-type="hotel"
                  :data-lat="hotel.lat"
                  :data-lng="hotel.lng"
                  :data-zoom="hotel.gmaps_zoom"
                  :data-name="hotel.title"
                data-current-tab="#gallery-tab"
                href="#">
                <span>{{$t('shared.cards.hotel.info_links.photos')}}</span>
              </a> </li>
            <li class="info-link utag-info-map">
              <a :data-multi-modal-trigger="hotel.id"
                  data-type="hotel"
                  :data-lat="hotel.lat"
                  :data-lng="hotel.lng"
                  :data-zoom="hotel.gmaps_zoom"
                  :data-name="hotel.title"
                data-current-tab="#map-tab"
                href="#">
                <span>{{$t('shared.cards.hotel.info_links.map')}}</span>
              </a> </li>
          </ul>
        </div>

        <div v-if="isPrivateArea" class="call-to-action" data-more-info="Más información">
          <div class="new-hotel" v-if="hotel.next_opening">
            <div class="new-hotel-box">
              <span class="s s-calendar icon s-2x" aria-label="calendar"></span>
              <p class="ann">{{$t('shared.next_opening.announcement')}}</p>
              <p class="desc">{{$t('shared.next_opening.date', {date: this.formatDate(hotel.next_opening_date, $locale) })}}</p>
            </div>
            <a :href="hotel.url" class="secondary-btn hide-in-app" >
              {{$t('shared.next_opening.visit_hotel')}}
            </a>
          </div>
          <div class="price-info price-wrapper" v-else>
            <div class="accomodation" v-if="hotel.price_board">
              <p>{{hotel.price_board}}</p>
            </div>
            <div class="price-cnt price-before">
              <span class="prev-type">{{$t('commons.iberostar_general_public_price')}}</span>
              <p class="prev-highlight">
                <span v-html="hotel.mib_price_html" ></span>
              </p>
            </div>
            <div class="price-cnt">
              <span class="type">{{$t('commons.exclusive_price')}}</span>
              <p class="highlight"
                data-availability-lightbox="#availability-dates-85">
                <span v-html="hotel.tcl_price_html" ></span>
              </p>
            </div>
          </div>
          <a class="btn-floating-fastbooking btn-primary btn-small js-book-btn"
              v-if="!hotel.next_opening"
              :data-hotel-room-name="hotel.title"
              :data-hotel-name="hotel.title"
              data-append-value="true"
              :data-hotel-id="`h${hotel.id}`"
              :data-utag-eec='`${hotel.data_eec}`'
              data-utag-click= '{"event_cat": "searcher", "event_act": "flexible dates", "event_lbl": "see calendar"}'
              redirect_to_ibooking="false"
              :href="`/reservas?currency_code=${hotel.tcl_currency}&vo_booking%5Bcheck_in_date%5D=${hotel.hotel_dates.check_in_date}&amp;vo_booking%5Bcheck_out_date%5D=${hotel.hotel_dates.check_out_date}&vo_booking%5BBhotel_id%5D=${hotel.id}&tipohabitaciones=${hotel.is_rose_gold == true ? 'rose' : ''}`">
              {{$t('commons.book_now')}}
          </a>
        </div>
      </div>
    </div>
  </div>

</template>
  <script>
  export default {
    name: 'HotelCard',
    props: {
      hotel: Object
    },
    methods: {
      formatDate: function(date, locale) {
        let formattedDate = new Date(date)
        return formattedDate.toLocaleDateString(locale)
      },
    },

    computed: {
      isIHG() {
        return this.hotel?.hotel_segmentations?.[0]?.title?.toLowerCase() === 'beachfront';
      }
    },

    data() {
      return {
        isPrivateArea: false,
      }
    },
    mounted() {
      this.isPrivateArea = document.body.classList.contains('private-page');
    },
  }
  </script>
